'use strict';

module.exports = strikethrough;

var all = require('../all');

/* Transform deletions. */
function strikethrough(h, node) {
  return h(node, 'del', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/delete.js
// module id = 963
// module chunks = 0